import qs from "qs";
import { createContext, ReactNode } from "react";
import * as ReactRouter from "react-router";
import * as sup from "superstruct";

import { notifyBugsnag } from "@/logging";

export function createQueryProvider(
  QueryContext: ReturnType<typeof createQueryContext>
) {
  return ({
    routeName,
    struct,
    children,
  }: {
    routeName: string;
    children: ReactNode;
    struct?: sup.Struct<unknown, unknown>;
  }) => {
    const location = ReactRouter.useLocation();

    const queryValues: unknown = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });

    const validQuery = struct ? maskQuery(queryValues, struct) : null;

    return (
      <QueryContext.Provider
        value={{
          routeName: routeName,
          query: validQuery,
        }}
      >
        {children}
      </QueryContext.Provider>
    );
  };
}

export function createQueryContext() {
  const QueryContext = createContext<{
    routeName: string;
    query: unknown;
  }>({
    get routeName(): never {
      throw new Error("routeName not provided");
    },
    get query(): never {
      throw new Error("query not provided");
    },
  });

  QueryContext.displayName = "QueryProvider";

  return QueryContext;
}

export function maskQuery<T, S>(value: unknown, struct: sup.Struct<T, S>) {
  try {
    return sup.mask(value, struct);
  } catch (err) {
    notifyBugsnag(err as Error);

    // eslint-disable-next-line no-console
    console.error("Route query validation failed due", err);

    return null;
  }
}
